export var WebAnalyticsAccountView;
(function (WebAnalyticsAccountView) {
    WebAnalyticsAccountView["AllAccounts"] = "all_accounts";
    WebAnalyticsAccountView["IntentModel"] = "intent_model";
})(WebAnalyticsAccountView || (WebAnalyticsAccountView = {}));
//# sourceMappingURL=WebAnalytics.js.map